import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-21fe7ec5")

_pushScopeId("data-v-21fe7ec5")
const _hoisted_1 = { class: "row container" }
const _hoisted_2 = { class: "nav-tree" }
const _hoisted_3 = { class: "list" }
const _hoisted_4 = { class: "col h-full align-center" }
const _hoisted_5 = { class: "cars-set-buttons w-full text-end flex" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createTextVNode("创建套卡 ")
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "font-bold" }, "成套卡牌列表", -1)
const _hoisted_9 = { class: "flex" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_13 = /*#__PURE__*/_createVNode("div", { class: "flex-1" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_category_tree = _resolveComponent("category-tree")
  const _component_tag_filter = _resolveComponent("tag-filter")
  const _component_el_button = _resolveComponent("el-button")
  const _component_card_set_detail = _resolveComponent("card-set-detail")
  const _component_card_set_assembly_list = _resolveComponent("card-set-assembly-list")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_card_set_form = _resolveComponent("card-set-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_card_set_preview = _resolveComponent("card-set-preview")
  const _component_el_drawer = _resolveComponent("el-drawer")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_category_tree, {
          currentCategoryId: _ctx.currentCategoryId,
          categoryType: "CARD_SET",
          onNodeClick: _ctx.filterCategory
        }, null, 8, ["currentCategoryId", "onNodeClick"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_tag_filter, {
              modelValue: _ctx.filterTags,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.filterTags = $event)),
              onSearch: _ctx.filterByTags
            }, null, 8, ["modelValue", "onSearch"]),
            _hoisted_6,
            _createVNode(_component_el_button, {
              type: "primary",
              icon: "el-icon-circle-plus-outline",
              onClick: _ctx.addNew
            }, {
              default: _withId(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _createVNode(_component_el_table, {
            data: _ctx.tableData.content,
            "row-key": "id",
            onRowClick: _ctx.expandRow,
            "expand-row-keys": [_ctx.currentRowId],
            class: "w-full table"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_table_column, { type: "expand" }, {
                default: _withId(({row}) => [
                  _createVNode(_component_card_set_detail, {
                    "card-set-id": row.id,
                    modelValue: row.parts,
                    "onUpdate:modelValue": ($event: any) => (row.parts = $event),
                    cardCount: row.cardCount
                  }, null, 8, ["card-set-id", "modelValue", "onUpdate:modelValue", "cardCount"]),
                  _hoisted_8,
                  _createVNode(_component_card_set_assembly_list, {
                    "card-set-id": row.id
                  }, null, 8, ["card-set-id"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "name",
                label: "名称",
                width: "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "category",
                label: "分类",
                width: "80"
              }, {
                default: _withId(({row}) => [
                  _createTextVNode(_toDisplayString(row.category.name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "cardCount",
                label: "张数",
                width: "80"
              }),
              _createVNode(_component_el_table_column, {
                prop: "description",
                label: "说明",
                "show-tooltip-when-overflow": "",
                width: "180"
              }),
              _createVNode(_component_el_table_column, {
                prop: "tags",
                width: "260px",
                label: "标签"
              }, {
                default: _withId(({row}) => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(row.tags, (tag) => {
                    return (_openBlock(), _createBlock(_component_el_tag, {
                      key: row.id + '-' + tag.id
                    }, {
                      default: _withId(() => [
                        _createTextVNode(_toDisplayString(tag.name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, { label: "操作" }, {
                default: _withId(({row}) => [
                  _createVNode("div", _hoisted_9, [
                    _createVNode(_component_el_button, {
                      size: "small",
                      class: "margin-right-10",
                      onClick: _withModifiers(($event: any) => (_ctx.preview(row)), ["stop"]),
                      type: "primary"
                    }, {
                      default: _withId(() => [
                        _hoisted_10
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_button, {
                      size: "small",
                      class: "margin-right-10",
                      onClick: _withModifiers(($event: any) => (_ctx.edit(row)), ["stop"]),
                      type: "warning"
                    }, {
                      default: _withId(() => [
                        _hoisted_11
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_el_popconfirm, {
                      onConfirm: ($event: any) => (_ctx.deleteCardSet(row)),
                      title: "确定删除吗？"
                    }, {
                      reference: _withId(() => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "danger"
                        }, {
                          default: _withId(() => [
                            _hoisted_12
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["onConfirm"])
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "onRowClick", "expand-row-keys"]),
          _hoisted_13,
          _createVNode(_component_el_pagination, {
            class: "margin-top-10",
            total: _ctx.tableData.totalCount,
            "page-count": _ctx.tableData.totalPages,
            "current-page": _ctx.tableData.pageNumber,
            onCurrentChange: _ctx.reloadPage,
            onPrevClick: _ctx.reloadPage,
            onNextClick: _ctx.reloadPage,
            background: "",
            layout: "total, prev, pager, next, jumper"
          }, null, 8, ["total", "page-count", "current-page", "onCurrentChange", "onPrevClick", "onNextClick"])
        ])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      title: "编辑套卡",
      modelValue: _ctx.cardSetDialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.cardSetDialogVisible = $event)),
      width: "60%"
    }, {
      default: _withId(() => [
        _createVNode(_component_card_set_form, {
          "card-set": _ctx.currentSelectedCardSet,
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cardSetDialogVisible = false)),
          onSuccess: _ctx.cardSetCreated
        }, null, 8, ["card-set", "onSuccess"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      title: "预览",
      direction: "ltr",
      modelValue: _ctx.previewDialogVisible,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.previewDialogVisible = $event)),
      size: "60%"
    }, {
      default: _withId(() => [
        _createVNode(_component_card_set_preview, {
          saveable: true,
          "card-set-id": _ctx.previewCardSetId,
          "card-set-parts": _ctx.cardSetParts,
          onAssemblyCreated: _ctx.assemblyCreated
        }, null, 8, ["card-set-id", "card-set-parts", "onAssemblyCreated"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})